import { render, staticRenderFns } from "./v-select-custom.vue?vue&type=template&id=62a064ea"
import script from "./v-select-custom.vue?vue&type=script&lang=js"
export * from "./v-select-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports